export enum WorkspaceStatus {
    STOPPED = 1,
    RUNNING = 2,
    STARTING = 3,
    STOPPING = 4,
    RECONNECTING = 5,
  }